'use client';

import clsx from 'clsx';
import { createContext, useContext, type ReactNode } from 'react';
import Icon from '@publishing/components/ui/Icon';
import { ActionCloseType1 } from '@publishing/components/ui/SvgSprite';
import s from './CommonPopup.module.scss';

export const PopupCloseContext = createContext<() => void>(() => {});

interface PopupContentProps {
  className?: string;
  /** 닫기 버튼. 기본 black */
  close?: {
    type?: 'black' | 'white';
  };
  children: ReactNode;
}

export function PopupContent({ className, close, children }: PopupContentProps) {
  const onClose = useContext(PopupCloseContext);
  const closeType = close?.type ?? 'black';

  return (
    <div className={clsx(s.popup_content, className)}>
      {children}
      <button
        type="button"
        onClick={onClose}
        className={clsx(s.close, closeType === 'white' && s.light)}
        aria-label="닫기"
      >
        <Icon name={ActionCloseType1} size={16} color="white" aria-hidden />
      </button>
    </div>
  );
}

